import {SessionModel} from '../session/model';
import {Http} from '../../core/http';
import {ExtraApi} from './extra.api';
import {catchError, map, share} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {createExtra, ExtraModel, ExtraStructure} from './model';
import {SessionService} from '../session';

let fetchExtra$: Observable<ExtraStructure> | null;

const fetchExtra = (sessionId: SessionModel['sessionId']) => {
  if (!fetchExtra$) {
    const headers = {
      'X-AVP-Properties': 'Description',
      'X-AVP-PictureTemplates': 'Original|XLarge',
      'X-AVP-DescriptionType': 'text/plain',
    };
    fetchExtra$ = Http.get<any>(ExtraApi.get(sessionId), {headers}).pipe(
      share(),
      map(res => {
        const roomExtras = Object.keys(res.roomExtras).reduce((acc: object, key: string) => { //TODO CHECK FIX
          return {...acc, [key]: res.roomExtras[key].map((r: ExtraModel) => createExtra(r))};
        }, {});
        return {
          hotelExtras: res.hotelExtras.map((r: ExtraModel) => createExtra(r)),
          roomExtras: roomExtras
        };
      }),
      catchError(SessionService.shouldBeSessionError),
    );
  }

  return fetchExtra$;
};

const resetCacheFetchExtra = () => fetchExtra$ = null;

export const ExtraHelperService = {fetchExtra, resetCacheFetchExtra};
